export const currencyFormat = (number) => {

    return (new Intl.NumberFormat('de-DE', {currency: 'COL' }).format(Math.round(number)))
}